module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app-container"
  }, [_c('div', {
    staticClass: "head-container",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-row', {
    staticClass: "mb8",
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "span": 1.5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("家族总人数:" + _vm._s(_vm.data.sumMember))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1.5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("家族总流水(本月):" + _vm._s(_vm.data.sumPrice))])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 1.5
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "plain": "",
      "size": "mini"
    }
  }, [_vm._v("家族今日总流水:" + _vm._s(_vm.data.sumPriceByToDay))])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.data.runningWaterList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "日期",
      "align": "center",
      "prop": "dateStr"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "流水",
      "align": "center",
      "prop": "ls"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7fabdf49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/nav1/yingshoushuju.vue
// module id = 624
// module chunks = 1